import { Fragment } from 'react';
import AccordionCohabitant from './cohabitant';
import Cohabitation from './cohabitation';
import EditData from './edit-data';
import AccordionPerson from 'shell/components/shared/person';

const ResolutionCohabitation = (): React.ReactElement => {
  return (
    <Fragment>
      <AccordionPerson disabled />
      <EditData />
      <AccordionCohabitant />
      <Cohabitation />
    </Fragment>
  );
};

ResolutionCohabitation.displayName = 'Resolution Cohabitation component';

export default ResolutionCohabitation;
